angular.module('SpidApp')

.factory('OperationalProductService',
[        'OperationalProduct', 'Restangular',
function (OperationalProduct,   Restangular) {
	var OperationalProductService = {
		all: function () {
			
			return Restangular.all('/products/operational').getList().then(function (productsData) {
				
				var operationalProducts = _.chain(productsData).map(function (sub) {
					return new OperationalProduct(sub)
				}).value()
				
				return operationalProducts
			})
		}
	};

	return OperationalProductService;
}]);